import React, { useState } from 'react';
import '../styles/main.scss';
import './CreatePostPage.scss';
import { createPost } from '../api/api';
import { supabase } from '../lib/supabase';

interface Props {
  onCreated: () => void;
}

const PASSWORD = '1234';

const CreatePostPage: React.FC<Props> = ({ onCreated }) => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [type, setType] = useState('thoughts');
  const [image, setImage] = useState<File | null>(null);
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const handle = async () => {
    setError('');

    if (!title.trim()) {
      setTitle('...')
    }

    try {
      setLoading(true);

      let imageUrl = null;

      if (image) {
        const safeName = image.name
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-zA-Z0-9.\-_]/g, '_');

        const fileName = `posts/${Date.now()}_${safeName}`;

        const { error: uploadError } = await supabase.storage
          .from('images')
          .upload(fileName, image);

        if (uploadError) {
          console.log(uploadError);
          return;
        }

        const { data } = supabase.storage
          .from('images')
          .getPublicUrl(fileName);

        imageUrl = data.publicUrl;
      }

      await createPost({
        password: PASSWORD,
        title: title.trim(),
        content: content || '',
        type,
        image: imageUrl
      });

      setTitle('');
      setContent('');
      setImage(null);
      setError('');

      onCreated();
    } catch (e) {
      setError('Ошибка при создании поста');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-post">
      <div className="create-card">
        <h2>Создать пост</h2>

        {error && (
          <div style={{ color: 'red', marginBottom: 10 }}>
            {error}
          </div>
        )}

        <input
          placeholder="Название"
          value={title}
          onChange={e => setTitle(e.target.value)}
        />

        <textarea
          placeholder="Напиши что-нибудь..."
          value={content}
          onChange={e => setContent(e.target.value)}
        />

        <div className='file-upload flex'>
          <label>
            Добавить картинку
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setImage(e.target.files?.[0] || null)}
              hidden
            />
          </label>

          {image && (
            <div className="file-name">
              📎 {image.name}
            </div>
          )}

        </div>

        <p className='inter'>Выбери категорию поста: </p>

        <div className="type-selector">
          <button
            className={`thoughts ${type === 'thoughts' ? 'active' : ''}`}
            onClick={() => setType('thoughts')}
          >
            ✍️ Мысли
          </button>

          <button
            className={`music ${type === 'music' ? 'active' : ''}`}
            onClick={() => setType('music')}
          >
            🎵 Музыка
          </button>

          <button
            className={`video ${type === 'video' ? 'active' : ''}`}
            onClick={() => setType('video')}
          >
            🎥 Видео
          </button>

          <button
            className={`movie ${type === 'movie' ? 'active' : ''}`}
            onClick={() => setType('movie')}
          >
            🎬 Фильмы
          </button>

          <button
            className={`books ${type === 'books' ? 'active' : ''}`}
            onClick={() => setType('books')}
          >
            📚 Книги
          </button>

          <button
            className={`photos ${type === 'photos' ? 'active' : ''}`}
            onClick={() => setType('photos')}
          >
            📸 Фото
          </button>
        </div>

        <button onClick={handle} disabled={loading}>
          {loading ? 'Создание...' : 'Создать'}
        </button>
      </div>
    </div>
  );
};

export default CreatePostPage;